import { memo } from 'react'

import { ListItem } from '@mui/material'

import { UserInfo } from '@collaborate-health/uikit'
import { PluginUser } from '@tabeeb/modules/../users/types'

export interface ContentTrainingMaterialUserListItemProps {
  user: PluginUser
  children?: React.ReactNode
}

const ContentTrainingMaterialUserListItem: React.FC<ContentTrainingMaterialUserListItemProps> = ({
  user,
  children,
}) => {
  return (
    <ListItem disableGutters>
      <UserInfo
        item={{
          Id: user.id,
          Name: user.displayName,
          Email: user.email,
          IsAccountDeleted: user.isAccountDeleted,
          AvatarUrl: user.avatarUrl,
        }}
      />
      {children}
    </ListItem>
  )
}

export default memo(ContentTrainingMaterialUserListItem)

